import type { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import { createContext, useState } from 'react'

type EditContext = {
  isCancelDialogOpen: boolean
  isFormEditable: boolean
  setIsCancelDialogOpen: Dispatch<SetStateAction<boolean>>
  setIsFormEditable: Dispatch<SetStateAction<boolean>>
}

export const EditContext = createContext<EditContext>({
  isCancelDialogOpen: false,
  isFormEditable: false,
  setIsCancelDialogOpen: () => {},
  setIsFormEditable: () => {},
})

export const EditProvider = ({ children }: PropsWithChildren) => {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false)
  const [isFormEditable, setIsFormEditable] = useState(false)

  return (
    <EditContext.Provider
      value={{
        isCancelDialogOpen,
        isFormEditable,
        setIsCancelDialogOpen,
        setIsFormEditable,
      }}
    >
      {children}
    </EditContext.Provider>
  )
}
